import { create } from 'zustand';

const useInfoModalStore = create((set) => ({
  open: false,
  logoUrl: null,
  title: null,
  name: null,
  description: null,

  setOpen: (isOpen, data = {}) =>
    set(() => ({
      open: isOpen,
      logoUrl: data.logoUrl || null,
      title: data.title || null,
      name: data.name || null,
      description: data.description || null,
    })),

  closeModal: () =>
    set({
      open: false,
      logoUrl: null,
      title: null,
      name: null,
      description: null,
    }),
}));

export default useInfoModalStore;
